<div class="tam-contact-control">
    <textarea class="tam-input" [style.width.px]="childConfig.css.width" [style.height.px]="childConfig.css.height"
        [disabled]="true"></textarea>
</div>